import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/collapse";

import SideBarMenuStikcy from "design-system/resources/html/components/common/sidebar/sidebar";

import Header from "design-system/resources/html/components/common/header/header";
import NavbarMobile from "design-system/resources/html/components/common/navbar-mobile/navbar-mobile";

import Guides from "design-system/resources/html/components/common/guides/guides";
import ResponsiveTable from "design-system/resources/html/components/common/responsive-table/responsive-table";
import Tabs from "design-system/resources/html/components/faq/tabs/tabs";

import RiskWarningBar from "design-system/resources/html/components/common/risk-warning-bar/risk-warning-bar";

import getIdCarouselForAutoSlide from "./carousel";
import getIdCarouselForGlideSlide from './glide';
import addItemSessionStorage from "./addItemSessionStorage";
import mParticleLogEvent from "./mParticleLogEvent";

function getTabAndTabPanelActiveFromHash() {
  const buttons = document.querySelectorAll('button.nav-link');
  const tabs = document.querySelectorAll('div.tab-pane.fade');
  const hash = window.location.hash;

  if(hash) {
    buttons.forEach((btn) => btn.classList.remove("active"));
    tabs.forEach((tab) => tab.classList.remove("active", "show"));

    document.getElementById(hash.replace('#', '')).classList.add("active");
    document.querySelector('[aria-labelledby="' + hash.replace('#', '') + '"]').classList.add("show", "active");
  }
}

window.onload = function () {
  Header();
  NavbarMobile();
  getIdCarouselForAutoSlide();
  getIdCarouselForGlideSlide();
  Guides();
  ResponsiveTable();
  RiskWarningBar();
  Tabs();
  getTabAndTabPanelActiveFromHash();
  mParticleLogEvent();
  addItemSessionStorage();
  SideBarMenuStikcy();
};
